import { ChamberStaffUserViewModel } from "./types";

// CMP Dashboard (24) menu: "Generate" until the employee was ever given
// login details or signed in, then "Re-generate". UNKNOWN may have been
// emailed, so it counts as given (the pop-up then warns the old password stops).
export const staffCredentialsNeverIssued = (
  user: Pick<
    ChamberStaffUserViewModel,
    | "credentialDeliveryStatus"
    | "credentialsLastSentAtUtcMilli"
    | "credentialsLastDownloadedAtUtcMilli"
    | "lastLoginAtUtcMilli"
  >
) =>
  !user.lastLoginAtUtcMilli &&
  !user.credentialsLastSentAtUtcMilli &&
  !user.credentialsLastDownloadedAtUtcMilli &&
  user.credentialDeliveryStatus !== "SENT" &&
  user.credentialDeliveryStatus !== "UNKNOWN";

export const getStaffCredentialsActionLabel = (neverIssued: boolean) =>
  neverIssued
    ? "Generate Employee Login Credentials"
    : "Re-generate Employee Login Credentials";

// CMP Dashboard (24) downloadCreds: the file text is the design's, line for
// line. "Generated" is shown in the chamber time zone (dates rule).
export const buildStaffCredentialsFile = ({
  name,
  jobTitle,
  email,
  temporaryPassword,
  generatedAtUtcMilli,
  timeZone,
}: {
  name: string;
  jobTitle: string;
  email: string;
  temporaryPassword: string;
  generatedAtUtcMilli: number;
  timeZone?: string;
}) => ({
  fileName: `${(name || "employee").replace(/[^\w]+/g, "-")}-login-credentials.txt`,
  text:
    "Chamber Member Pro™ — Employee Login Credentials\r\n\r\n" +
    `Employee: ${name}\r\n` +
    `Title: ${jobTitle || "-"}\r\n` +
    `Username: ${email}\r\n` +
    `Temporary Password: ${temporaryPassword}\r\n` +
    `Generated: ${new Date(generatedAtUtcMilli).toLocaleString("en-CA", { timeZone })}\r\n\r\n` +
    "The employee will be asked to set a new password at first login.\r\n",
});
